import getFullComposeShowingInTabContentArea from 'owa-mail-compose-actions/lib/selectors/getFullComposeShowingInTabContentArea';
import findInlineComposeViewState from 'owa-mail-compose-actions/lib/utils/findInlineComposeViewState';
import {
    getSelectedTableView,
    isDumpsterTable,
    listViewStore,
    MailRowDataPropertyGetter,
} from 'owa-mail-list-store';
import { getStore as getReadingPaneStore } from 'owa-mail-reading-pane-store/lib/store/Store';
import { getActiveContentTab, TabType } from 'owa-tab-store';
import { isDumpsterSearchTable } from 'owa-mail-list-search';

export default function getCurrentReadingPaneId(): string | null {
    const tableQuery = listViewStore.tableViews.get(listViewStore.selectedTableViewId)?.tableQuery;
    const isDumpsterOrDumpsterSearchTable =
        tableQuery && (isDumpsterTable(tableQuery) || isDumpsterSearchTable(tableQuery));

    const activeTab = getActiveContentTab();
    const composeViewState = getFullComposeShowingInTabContentArea();
    const composeItemId = composeViewState?.itemId?.Id;

    if (composeItemId) {
        return composeItemId;
    }

    const { conversationReadingPaneViewState, deeplinkId } = getReadingPaneStore();

    if (deeplinkId) {
        // Deeplink
        return deeplinkId.id;
    } else if (activeTab && activeTab.type === TabType.SecondaryReadingPane) {
        const secondaryReadingPaneTabData = activeTab.data;
        return secondaryReadingPaneTabData?.id?.Id;
    } else if (
        conversationReadingPaneViewState &&
        findInlineComposeViewState(conversationReadingPaneViewState.conversationId.Id)
    ) {
        // RP has inline compose open
        return conversationReadingPaneViewState.conversationId.Id;
    } else {
        const tableView = getSelectedTableView();
        const selectedRowKeys = tableView && [...tableView.selectedRowKeys.keys()];
        const isInVirtualSelectAllMode = tableView?.isInVirtualSelectAllMode;
        const selectedItemPartsCount =
            listViewStore.expandedConversationViewState?.selectedNodeIds?.length;
        if (
            selectedRowKeys?.length === 1 &&
            selectedItemPartsCount <= 1 &&
            !isInVirtualSelectAllMode &&
            !isDumpsterOrDumpsterSearchTable
        ) {
            // 1 row selected: display reading pane only if select all is not checked and not in dumpster or dumpster search
            const rowId = MailRowDataPropertyGetter.getRowClientItemId(
                selectedRowKeys[0],
                tableView
            );
            return rowId.Id;
        }
    }

    return null;
}
